import React from 'react';
import CampTemplate from '../camp-template';
import ValeriaImage from 'assets/img/valeria-space-camp.jpg';
import styles from './styles.module.scss';

const VALERIA_LEARNING_CENTER_ID = 3;

const TrainLikeAnAstronaut = () => (
  <CampTemplate
    learningCenterId={VALERIA_LEARNING_CENTER_ID}
    planId={4}
    headerTitle="Train Like an Astronaut"
    headerSubtext="Join me in uncovering relationships between living things, unlocking different types of energy sources, exploring different planets, and finding out what we can learn from our observations and math."
    headerImage={ValeriaImage}
    whenContent={
      <React.Fragment>
        <ul className="list-unstyled">
          <li>
            <strong>SESSION A:</strong> June 15 - June 25th
          </li>
          <li>
            <strong>SESSION B:</strong> July 6 - July 16
          </li>
          <li>
            <strong>SESSION C:</strong> July 20 - July 30
          </li>
        </ul>
        <p className={styles.valueProp}>
          Each session is 8 classes, Monday-Thursday 10AM - 12PM (2 hours each).
          LIMIT to 10 learners per session. $425 per learner.
        </p>
      </React.Fragment>
    }
    whoContent={
      <p className={styles.valueProp}>
        Learners in 1st-5th grade. GREAT FOR FRIENDS TO DO TOGETHER!
      </p>
    }
    whatContent={
      <React.Fragment>
        <p className={styles.valueProp}>
          This fully remote/online program uses a private Zoom conference room
          and the Unyted.co online platform so learners participate in physical
          and online activities modeled after the real-life physical,
          intellectual (academic), social, and emotional requirements of humans
          traveling in space.
        </p>
        <p>
          In addition to developmentally appropriate science and math skills,
          your child will learn about nutrition, engineering, innovative
          thinking, and develop problem solving skills that mirror those of a
          future astronaut. Best of all, it happens in a more engaging and fun
          online *social* environment unmatched by other programs because of the
          Unyted.co group problem solving technology!
        </p>
      </React.Fragment>
    }
  />
);

export default TrainLikeAnAstronaut;
